import React from 'react'
import { cnMerge } from '../../utils/twmerge'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  error?: boolean
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cnMerge(
          // Base styles
          'flex h-9 w-full rounded-md border bg-white dark:bg-neutral-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100',
          // Border styles - conditional for error state
          error 
            ? 'border-red-500 dark:border-red-400' 
            : 'border-gray-300 dark:border-neutral-600',
          // Placeholder styles
          'placeholder:text-gray-500 dark:placeholder:text-gray-400',
          // Focus styles - conditional for error state
          error
            ? 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500/20 dark:focus-visible:ring-red-400/20 focus-visible:border-red-500 dark:focus-visible:border-red-400'
            : 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/20 dark:focus-visible:ring-blue-400/20 focus-visible:border-blue-500 dark:focus-visible:border-blue-400',
          // Transition para suavidade
          'transition-colors duration-200',
          // Disabled styles
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50 dark:disabled:bg-neutral-900',
          // File input adjustments
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-gray-700 dark:file:text-gray-300',
          // Range input adjustments
          'range:appearance-none range:bg-transparent range:cursor-pointer',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'
